module.exports = __webpack_public_path__ + "static/media/darkTimline.79b93fb9.svg";